<template>
 
      <div class="px-6 flex justify-between items-center pb-8">
        <router-link  to="/"  class="flex justify-center items-center bg-g300 w-12 h-12 rounded-full text-2xl !leading-none text-white">
          <i class="ph ph-caret-left"></i>
        </router-link> 
        <div class="flex-1 flex justify-center items-center pr-12">
          <p class="text-2xl font-semibold">Register Karyawan</p>
        </div>
      </div>
            


      <form class="flex flex-col gap-4 pt-8 px-6 relative">
         <pulse-loader :loading="loading" :color="color" :size="size" style="position: absolute; top: 50%; right: 45%;  "></pulse-loader>
        <div class="flex flex-col justify-start">
          <p class="text-sm font-semibold pb-2 dark:text-white">Nama</p>
          <div class="p-4 bg-n20 border border-n40 dark:bg-darkN20 dark:border-darkN40 rounded-xl">
            <input type="text"  v-model="name" placeholder="Nama" class="w-full bg-transparent outline-none placeholder:text-n90 text-sm dark:text-white" autocomplete="off">
          </div>
        </div>
        <div class="flex flex-col justify-start">
          <p class="text-sm font-semibold pb-2 dark:text-white">Username</p>
          <div class="p-4 bg-n20 border border-n40 dark:bg-darkN20 dark:border-darkN40 rounded-xl">
            <input type="text" v-model="username" placeholder="username" class="w-full bg-transparent outline-none placeholder:text-n90 text-sm dark:text-white" autocomplete="off" disabled>
          </div>
        </div>
        <div class="flex flex-col justify-start">
          <p class="text-sm font-semibold pb-2 dark:text-white">Jabatan</p>
          <div class="p-4 bg-n20 border border-n40 dark:bg-darkN20 dark:border-darkN40 rounded-xl">
            <input type="text" v-model="jabatan" placeholder="jabatan" class="w-full bg-transparent outline-none placeholder:text-n90 text-sm dark:text-white">
          </div>
        </div>
      
     
      
        <div class="my-3 flex">
          <button  class="flex-1 py-3 bg-g300 text-white text-center rounded-xl" @click="submit()">Save</button>
           <button  class="flex-1 py-3 bg-g300 text-white text-center rounded-xl" @click="reg_wajah()">Daftar Wajah</button>
        </div>
      </form>
       <p v-if="error" class=" px-6 " style="color:red">{{ error }}</p>
  
    </template>

<script setup>
import { ref,onMounted } from "vue"
import { useRoute,useRouter } from "vue-router";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

const name = ref("")
const username = ref("")
const jabatan = ref("")
 
const error = ref(null)
const loading = ref(false)
const route = useRoute()
const router = useRouter();

 

onMounted(async () => {
  
  const token = localStorage.getItem("token");

  const res = await fetch("https://kiyanrahayu.my.id/api2/getuserid?id=" + route.params.id,{
      headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       }
    })

     if(res.ok){
        const model = await res.json() 

        name.value = model.name
         username.value = model.email
        jabatan.value = model.jabatan      

     }

})

function reg_wajah(){
     router.push("/daftar/" +  route.params.id );
}

async function submit() {
  loading.value = true
  const formData = new FormData()
  formData.append("name", name.value)   
  formData.append("jabatan", jabatan.value) 
  formData.append("cmd", 'edit')
  formData.append("id", route.params.id )

  const token = localStorage.getItem("token");

 const res = await fetch("https://kiyanrahayu.my.id/api2", {
    method: "POST",
    headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       },
    body: formData
  })

  if(res.ok){
    loading.value = false
     router.push("/list-karyawan");
  }else{
    loading.value = false
    error.value = "Error server";
  }
    
}

</script>